import styled from "styled-components";

// export const hubspotForm = styled.div`
//   background: white;
//   padding: 0.5rem 1rem;
//   border-radius: 1rem;
// `;

export const MailchimpContactFormWrapper = styled.div`
      background: white;
      padding: 0 0 0;
      border-radius: 1rem;
      margin-top: 50px;
      margin-right: 20px;
      margin-bottom: 4rem;
      overflow: hidden;
`;

export const McFieldGroup = styled.div`

`;